import {
  FilterGroup,
  HeaderConfig,
  Row,
} from 'components/Table/KhulaSupplierTable';
import {IDepot} from 'constants/interfaces';
import React from 'react';
import {Box, IconButton, Tooltip} from '@material-ui/core';
import {_ToTitleCase} from 'constants/index';
import EditIcon from '@material-ui/icons/Edit';
import CheckIcon from '@material-ui/icons/Check';
import CloseIcon from '@material-ui/icons/Close';

export const depotTableHeaders: HeaderConfig[] = [
  {
    field: 'id',
    title: 'Depot',
    isSortable: true,
    isSearchable: true,
    isRightAligned: true,
  },
  {
    field: 'name',
    title: 'Name',
    isSortable: true,
    isSearchable: true,
    isRightAligned: false,
  },
  {
    field: 'formattedAddress',
    title: 'Address',
    isSortable: true,
    isSearchable: true,
    isRightAligned: false,
    maxWidth: 200,
  },
  {
    field: 'isActiveFormatted',
    title: 'Active',
    isSortable: true,
    sortField: 'isActive',
    isSearchable: false,
    isRightAligned: true,
  },
  {
    field: 'contact',
    title: 'Contact Name',
    isSortable: true,
    isSearchable: true,
    isRightAligned: false,
  },
  {
    field: 'phone',
    title: 'Contact Phone',
    isSortable: false,
    isSearchable: false,
    isRightAligned: false,
  },
  {
    field: 'actions',
    title: '',
    isSortable: false,
    isSearchable: false,
    isRightAligned: true,
  },
];

export const depotTableRows = (
  depots: IDepot[],
  onEdit: (depot: IDepot) => any,
): Row[] =>
  depots.map((depot) => ({
    // Don't spread the entire `depot` object
    id: parseInt(depot.id as any),
    name: depot.name,
    formattedAddress: formattedDepotAddress(depot),
    formattedLatLong: `${depot.latitude}, ${depot.longitude}`,
    isActiveFormatted: depot.isActive ? <CheckIcon /> : <CloseIcon />,
    contact: depot.contact || '', // add more fields as needed
    phone: depot.phone || '', // or convert to string if needed
    actions: <DepotRowIcons onEdit={() => onEdit(depot)} />,
  }));

export const formattedDepotAddress = (depot: IDepot) => {
  return [
    depot.address1,
    depot.address2,
    depot.address3,
    depot.address4,
    depot.address5,
  ]
    .filter((line) => !!line)
    .map((line) => line.trim())
    .map((line) => _ToTitleCase(line))
    .join(', ');
};

function DepotRowIcons(props: {onEdit: () => any}) {
  return (
    <Box display="flex" flexDirection="row">
      <Tooltip title="Edit depot" aria-label="edit depot">
        <IconButton aria-label="edit depot" size="small" onClick={props.onEdit}>
          <EditIcon fontSize="inherit" />
        </IconButton>
      </Tooltip>
    </Box>
  );
}

const activeFilterGroup: FilterGroup = {
  name: 'Status',
  filters: [
    {
      field: 'isActive',
      value: true,
      title: 'Active',
    },
    {
      field: 'isActive',
      value: false,
      title: 'Inactive',
    },
  ],
};

export const depotTableFilters = [activeFilterGroup];
